"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Spinner;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _classnames = _interopRequireDefault(require("classnames"));

var _SpinnerModule = _interopRequireDefault(require("./Spinner.module.scss"));

var _Spinner = _interopRequireDefault(require("./Spinner.i18n"));

var _assets = require("../../../assets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TRIANGLE_IMG = "".concat(_assets.ASSETS_LOGOS, "/fhx/triangle_centered.gif");

function Spinner(_ref) {
  var _ref$imageFile = _ref.imageFile,
      imageFile = _ref$imageFile === void 0 ? TRIANGLE_IMG : _ref$imageFile,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 200 : _ref$width,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 0.6 : _ref$duration,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? "" : _ref$text,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var styleImg = {
    width: "".concat(width, "px"),
    animationDuration: "".concat(duration, "s")
  };
  var styleText = {
    width: "".concat(width, "px")
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_SpinnerModule.default.spinner, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: imageFile,
    className: _SpinnerModule.default.img,
    style: styleImg,
    alt: formatMessage(_Spinner.default.altText)
  }), text !== "" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("div", {
    className: _SpinnerModule.default.text,
    style: styleText
  }, text)));
}